import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstrumentsChecksumInputComponent } from './instruments-checksum-input.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';


@NgModule({
  declarations: [
    InstrumentsChecksumInputComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
  ],
  providers: [
    TranslatePipe,
  ],
  exports: [
    InstrumentsChecksumInputComponent
  ]
})
export class InstrumentsChecksumInputModule { }
